(function () {
  'use strict';

  angular.module('ringbaPortal').component('audioPlayerBtn', {
    bindings: {
      url: '@',
      inboundNumber: '@'
    },
    controller: AudioPlayerBtnController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/audio-player/audio-player-btn.view.html'
  });

  function AudioPlayerBtnController(
    toaster
  ) {
    'ngInject';

    const vm = this;

    vm.showAudioPlayer = showAudioPlayer;
    vm.stopAudioPlayer = stopAudioPlayer;

    function showAudioPlayer() {
      toaster.clear('miscellaneous-toaster', 'audio-player');
      vm.audioToaster = toaster.pop({
        toasterId: 'miscellaneous-toaster',
        toastId: 'audio-player',
        type: 'audio',
        body: 'toaster-player',
        bodyOutputType: 'directive',
        'newest-on-top': true,
        directiveData: {
          url: vm.url,
          inboundNumber: vm.inboundNumber
        },
        timeout: 0,
        tapToDismiss: false,
        showCloseButton: true,
        iconClass: 'toast-audio',
        onHideCallback: function () {
          vm.audioToaster = null;
        }
      });
    }

    function stopAudioPlayer() {
      toaster.clear(vm.audioToaster);
    }

  }
})();
